"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependentAvailableToolIdentifierAccessLevel = void 0;
exports.DependentAvailableToolIdentifierAccessLevel = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
